import React from 'react';
export function Footer() {
  return <footer className="bg-[#061b2e] px-4 py-5 text-center" data-id="element-64" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl space-y-2" data-id="element-65" data-mp="3gfivmltl4hfp">
        <p className="text-[11px] font-medium leading-snug text-ice/70" data-id="element-66" data-mp="3ghc508vl1fre">
          © 2026 PROSTHODONTICS VISUAL ATLAS™ — All Rights Reserved. PROSTHODONTICS VISUAL
          ATLAS™ provides educational study and revision resources for dental students. It
          does not replace accredited dental education, supervised clinical training,
          faculty instruction, current evidence, institutional protocols, manufacturer
          instructions or qualified professional judgment.
        </p>
        <nav aria-label="Legal" className="flex flex-wrap justify-center gap-2 text-[11px] font-bold uppercase tracking-wide text-ice/80" data-id="element-67" data-mp="3lggaopjasvcz">
          <a href="#" className="transition-colors duration-150 hover:text-teal" data-id="element-68" data-mp="29ydwk0ehj49w">
            Terms &amp; Conditions
          </a>
          <span aria-hidden="true" data-id="element-69" data-mp="2ew70emsbfm70">•</span>
          <a href="#" className="transition-colors duration-150 hover:text-teal" data-id="element-70" data-mp="3l8qv40rs6dpv">
            Privacy Policy
          </a>
          <span aria-hidden="true" data-id="element-71" data-mp="3gbqyshkqgpby">•</span>
          <a href="#" className="transition-colors duration-150 hover:text-teal" data-id="element-72" data-mp="3gctmyhqo8do6">
            Contact
          </a>
        </nav>
      </div>
    </footer>;
}